export class Category {
  public categoryId: string;
  public name: string;
  public description: string;
  public image: string;
  public status: string;
}
